import React from 'react';

import Heading from 'components/reusable/authorization/Heading/Heading.layout';
import { Button } from 'components/reusable/Buttons/Button';
import ButtonsWrap from 'components/reusable/Buttons/ButtonsWrap.styled';
import { PaymentDeclinedProps } from './PaymentDeclined.types';


export default function PaymentDeclined(props: PaymentDeclinedProps) {
    const { t } = props;

    return (
        <main>
            <Heading
                pageHeader={t('paymentDeclined.header')}
                iconName="closeCircle"
                iconColor="error.base"
                pageSubheader={t('paymentDeclined.subHeader')}
            />

            <ButtonsWrap>
                <Button onClick={() => props.dispatchFinishWorkflow()} variant="error">{t('common:buttons.redirectBack.text')}</Button>
            </ButtonsWrap>
        </main>
    );
}
